import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import { useMediaQueryDown } from '../../../../../../hooks/useMediaQuery';
import { InlineContainer, SpacingContainer } from '../../../../../../components/common/Containers';
import { SelectAllMenu } from '../../../../../../components/common/Inputs/CheckBox';
import { TextField } from '../../../../../../components/common/Inputs';
// import { ROWS_PER_PAGE_OPTIONS } from '../../../../../../hooks/usePagination'
import CreateIcon from '@material-ui/icons/Create';
import { ReactComponent as ArchiveIcon } from '../../../icons/ico-remove.svg';
import LocalOfferOutlinedIcon from '@material-ui/icons/LocalOfferOutlined';
import { IconInbox } from '../../../../../../components/svg/Icons';
import ShowColumns from './components/ShowColumns';
import Filters from './components/Filters';
import PaginationSmall from '../../../../../../components/common/Paginations/PaginationSmall';
import RestoreFromTrashIcon from '@material-ui/icons/RestoreFromTrash';
import Tooltip from '../../../../../../components/common/Tooltip';
import Typography from '../../../../../../components/common/Typography';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import ConfirmDialog from '../../../../../../components/generics/Confirm/Dialog';
import connect from '../../../connect';

const ActionsPanel = ({
  items,
  checkAll,
  uncheckAll,
  isAllChecked,
  isSomeChecked,
  filters,
  changeFilters,
  getList,
  changeCurrentView,
  archiveSelected,
  currentView,
  openAddTags,
  count,
  changeEditVendorManagement,
  openAddVendorManually,
  deleteVendorManagement,
  getDashboard,
  filterDefault,
  pending,
}) => {
  const isSmScreen = useMediaQueryDown('sm');
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [page, setPage] = useState(filters.pagination.page);
  const ROWS_PER_PAGE_OPTIONS = [10, 20, 50];

  const onCheckAll = () => checkAll();
  const onRemoveAllChecked = () => uncheckAll();

  const changePage = (newPage) => {
    const updated = {
      ...filters,
      type: filterDefault,
      pagination: { ...filters.pagination, page: newPage },
    };
    changeFilters(updated);
    getList(updated);
    setPage(newPage);
  };

  const changeRowPerPage = (newPerPage) => {
    const updated = {
      ...filters,
      type: filterDefault,
      pagination: { page: 1, perPage: newPerPage },
    };
    changeFilters(updated);
    getList(updated);
    setPage(1);
  };

  const showVendors = () => {
    changePage(1);
    const updated = {
      ...filters,
      where: { archived: false, draft: false },
      pagination: { page: 1, perPage: filters.pagination.perPage },
    };
    changeFilters(updated);
    getList(updated);
    changeCurrentView('vendors');
  };

  const showArchivedVendors = () => {
    changePage(1);
    const updated = {
      ...filters,
      where: { archived: true, draft: false },
      pagination: { page: 1, perPage: filters.pagination.perPage },
    };
    changeFilters(updated);
    getList(updated);
    changeCurrentView('vendorsArchived');
  };

  const showDraft = () => {
    changePage(1);
    const updated = {
      ...filters,
      where: { archived: false, draft: true },
      pagination: { page: 1, perPage: filters.pagination.perPage },
    };
    changeFilters(updated);
    getList(updated);
    changeCurrentView('draft');
  };

  const onArchiveSelected = () => {
    const ids = items.filter((i) => i.checked).map((i) => i.id);
    archiveSelected({ ids, view: currentView });
    changePage(1);
  };

  const onEditSelected = () => {
    const vendor = items.find((i) => i.checked);
    changeEditVendorManagement(vendor);
    openAddVendorManually(true);
  };

  const showEditButton = () => {
    const checked = items.filter((i) => i.checked);
    return checked.length === 1 && checked[0].status !== 'Registered';
  };

  const onAddTag = () => openAddTags(true);
  const openDeleteModal = () => setOpenDeleteConfirm(true);

  const onDeleteSelected = () => {
    const ids = items.filter((i) => i.checked).map((i) => i.id);
    deleteVendorManagement({ ids, view: currentView })
      .then(() => {
        changePage(1);
        getDashboard({});
      })
      .catch((err) => console.error(err));
  };

  const handleConfirmDelete = () => {
    onDeleteSelected();
    setOpenDeleteConfirm(false);
  };

  return (
    <>
      <SpacingContainer px={3} py={2} style={{ background: 'white' }}>
        <Grid container alignItems="center" wrap="nowrap" justifyContent="space-between">
          <Grid item>
            <InlineContainer spacing={isSmScreen ? 2 : 1}>
              <SelectAllMenu
                isSomeChecked={isSomeChecked}
                isAllChecked={isAllChecked}
                onCheckAll={onCheckAll}
                onRemoveAllChecked={onRemoveAllChecked}
              />

              {isSomeChecked && (
                <>
                  <IconButton onClick={onAddTag}>
                    <Tooltip
                      placement="top"
                      RefComponent="span"
                      title={<Typography variant="body2">Add tag</Typography>}
                    >
                      <LocalOfferOutlinedIcon />
                    </Tooltip>
                  </IconButton>

                  {showEditButton() && (
                    <IconButton onClick={onEditSelected}>
                      <Tooltip
                        placement="top"
                        RefComponent="span"
                        title={<Typography variant="body2">Edit</Typography>}
                      >
                        <CreateIcon />
                      </Tooltip>
                    </IconButton>
                  )}

                  {currentView !== 'draft' && (
                    <IconButton onClick={onArchiveSelected}>
                      <Tooltip
                        placement="top"
                        RefComponent="span"
                        title={
                          <Typography variant="body2">
                            {currentView === 'vendorsArchived' ? 'Unarchive' : 'Archive'}
                          </Typography>
                        }
                      >
                        {currentView === 'vendorsArchived' ? <RestoreFromTrashIcon /> : <IconInbox archive />}
                      </Tooltip>
                    </IconButton>
                  )}

                  <IconButton onClick={openDeleteModal}>
                    <Tooltip
                      placement="top"
                      RefComponent="span"
                      title={<Typography variant="body2">Delete</Typography>}
                    >
                      <ArchiveIcon />
                    </Tooltip>
                  </IconButton>
                </>
              )}
            </InlineContainer>
          </Grid>

          <Grid item>
            <InlineContainer spacing={3}>
              <InlineContainer>
                <PaginationSmall
                  count={count}
                  page={page}
                  perPage={filters.pagination.perPage}
                  onChangePage={changePage}
                  pending={pending}
                  px={5}
                  py={1}
                  actions={
                    <TextField
                      select
                      value={String(filters.pagination.perPage)}
                      onChange={(e) => changeRowPerPage(Number(e.target.value))}
                      style={{ width: 82 }}
                    >
                      {ROWS_PER_PAGE_OPTIONS.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                  }
                />

                <Tooltip
                  placement="top"
                  RefComponent="span"
                  title={<Typography variant="body2">Active vendors</Typography>}
                >
                  <IconButton
                    color={!filters.where.archived && !filters.where.draft ? 'secondary' : 'default'}
                    onClick={showVendors}
                  >
                    <IconInbox />
                  </IconButton>
                </Tooltip>

                <Tooltip
                  placement="top"
                  RefComponent="span"
                  title={<Typography variant="body2">Archived vendors</Typography>}
                >
                  <IconButton color={filters.where.archived ? 'secondary' : 'default'} onClick={showArchivedVendors}>
                    <IconInbox archive />
                  </IconButton>
                </Tooltip>

                <Tooltip
                  placement="top"
                  RefComponent="span"
                  title={<Typography variant="body2">Draft vendors</Typography>}
                >
                  <IconButton color={filters.where.draft ? 'secondary' : 'default'} onClick={showDraft}>
                    <BorderColorIcon />
                  </IconButton>
                </Tooltip>

                <Tooltip
                  placement="top"
                  RefComponent="span"
                  title={<Typography variant="body2">Visible columns</Typography>}
                >
                  <ShowColumns />
                </Tooltip>

                <Tooltip placement="top" RefComponent="span" title={<Typography variant="body2">Filters</Typography>}>
                  <Filters />
                </Tooltip>
              </InlineContainer>
            </InlineContainer>
          </Grid>
        </Grid>
      </SpacingContainer>

      <ConfirmDialog
        open={openDeleteConfirm}
        onClose={() => setOpenDeleteConfirm(false)}
        onConfirm={handleConfirmDelete}
        pending={pending}
        title="Delete Vendor(s)"
        text="Are you sure you want to delete the selected vendor(s)?"
      >
        <Typography color="hint">Please note that this action cannot be undone.</Typography>
      </ConfirmDialog>
    </>
  );
};

export default connect(ActionsPanel);
